/*
 * 版权声明
 * 上海万位数字技术有限公司（以下简称“本公司”）对其自行研究开发、编写编制的软件程序、代码等（以下简称“研发资料”）均受《中华人民共和国反不正当竞争法》、《中华人民共和国著作权法》、《中华人民共和国专利法》及适用之国际公约中有关著作权、专利权及/或其他财产所有权法律的保护，为本公司专属或持有。
 * 使用者将本公司专属或持有的研发资料用于商业、营利、广告性目的时，需事先征得本公司书面特别授权，并注明出处“上海万位数字技术有限公司”，并按照有关国际公约及中华人民共和国法律的有关规定，向本公司支付使用费。
 * 未经本公司事先明确的书面特别授权，任何单位或个人不得以任何形式、任何途径，通过任何渠道变更、篡改、发行、发布、散布、复制、重制、展示或利用研发资料全部或部分内容，否则以侵权论，依法追究法律责任。
 *
 * Copyright Notice
 * All the software programs and codes among others (hereinafter referred to as the R&D data) solely developed and written by Shanghai Wanway Digital Technology Co., Ltd. (hereinafter referred to as the Company) are protected by the Law of the People's Republic of China against Unfair Competition, Copyright Law of the People's Republic of China, Patent Law of the People's Republic of China and provisions on laws of copyrights, patent rights and/or other property ownership in international conventions that apply and exclusive to or owned by the Company.
 * While using the R&D data exclusive to or possessed by the Company for any commercial, marketing, or advertising purpose, users need ask for special authorization from the Company in writing beforehand, note the source "Shanghai Wanway Digital Technology Co., Ltd." and pay the Company royalties subject to relevant provisions in related international conventions and laws of the People's Republic of China.
 * With no prior and express written special authorization from the Company, any unit or individual shall not alter, tamper, issue, release, distribute, duplicate, remake, produce or use part or all of the R&D data in any form and any way, otherwise it shall be deemed as infringement and subject to legal penalties by law.
 */
import React from 'react';
import { Popover, Button} from 'antd';
import SendDirective from './SendDirective';
import DeviceDirectiveRecord from './DeviceDirectiveRecord';
import {WWUtils,WWMethods} from "@/tools";
import "./index.scss"
class DeviceDirective extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            setInstructionList: [],
            controlInstructionList: [],
            inquiryInstructionList: [],
            customInstructionList: [],
            record: {},
            showDirective: false,
            instruction: {},
            directiveList: [],
            isOnline: false,
            heartTime: '',
            setVisible: false,
            controlPopoverVisible: false,
            inquiryPopoverVisible: false,
            showRecord: false,
        };
        this.getInstructionList = this.getInstructionList.bind(this);
        this.setInstruction = this.setInstruction.bind(this);
        this.resetInstruction = this.resetInstruction.bind(this);
        this.handleSetVisibleChange = this.handleSetVisibleChange.bind(this);
        this.handleControlPopoverVisibleChange = this.handleControlPopoverVisibleChange.bind(this);
        this.handleInquiryPopoverVisibleChange = this.handleInquiryPopoverVisibleChange.bind(this);
        this.showRecord = this.showRecord.bind(this);
        this.formatPropsData = this.formatPropsData.bind(this)
    }

    componentDidMount() {
        if(this.props.imei){
            this.formatPropsData(this.props.imei);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.imei) {
            if (nextProps.imei !== this.props.imei) {
               this.formatPropsData(nextProps.imei);
            }
        }
    }
    //根据父级组件传递的imei获取设备状态以及最后信号时间和设备详情
    formatPropsData(imei){
        this.getInstructionList(imei);
    }
    //查询指令模板
    getInstructionList(imei) {
        let that = this;
        WWMethods.getCmdTemplate(imei,(data)=>{
            let templates = data.templates;
            let setInstructionList = [];
            let controlInstructionList = [];
            let inquiryInstructionList = [];
            let customInstructionList = [];
            let isOnline = data.isOnline;
            let heartTime;
            if(data.latestActiveTime){
                heartTime =  WWUtils.formatTimeYMDHms(data.latestActiveTime);
            }
            templates.forEach(function (item) {
                if (item.type == 1) {
                    setInstructionList.push(item)
                } else if (item.type == 2) {
                    controlInstructionList.push(item)
                } else if (item.type == 3) {
                    inquiryInstructionList.push(item)
                }else if (item.type == 4) {
                    customInstructionList.push(item)
                }
            })
            that.setState({
                setInstructionList: setInstructionList,
                controlInstructionList: controlInstructionList,
                inquiryInstructionList: inquiryInstructionList,
                customInstructionList: customInstructionList,
                record:data,
                showDirective: false,
                showRecord: false,
                heartTime: heartTime,
                isOnline
            })
        })

    }

    setInstruction(instruction) {
        return () => {
            instruction.imei = this.state.record.imei;
            let directiveList;
            if (instruction.param) {
                directiveList = instruction.param.beanList;
            }
            this.setState({
                showDirective: true,
                showRecord: false,
                instruction: instruction,
                directiveList: directiveList,
                setVisible: false,
                controlPopoverVisible:false,
                inquiryPopoverVisible:false
            })

        }
    }

    resetInstruction() {
        this.setState({
            showDirective: false,
            showRecord: false,
            isOnline: false,
            heartTime: ''
        }, () => {
            this.refs.sendDirective && this.refs.sendDirective.resetFields();
        })
    }

    handleSetVisibleChange(visible) {
        this.setState({
            setVisible: visible
        })
    }

    handleControlPopoverVisibleChange(visible) {
        this.setState({
            controlPopoverVisible: visible
        })
    }

    handleInquiryPopoverVisibleChange(visible) {
        this.setState({
            inquiryPopoverVisible: visible
        })
    }

    showRecord() {
        this.setState({
            showRecord:true,
            showDirective:false,
        },()=>{
            this.refs.record.getDeviceRecord()
        })
    }


    render() {
        const {record, setVisible,controlPopoverVisible,inquiryPopoverVisible,showRecord,showDirective,setInstructionList,controlInstructionList} = this.state;
        let that = this;
        let setLi = setInstructionList.map(function (item, index) {
            return (
                <div className="content-item" key={item.instructionId} onClick={that.setInstruction(item)}>
                    <span>{item.name}</span>
                </div>
            )
        })
        let controlLi = controlInstructionList.map(function (item, index) {
            return (
                <div className="content-item" key={item.instructionId} onClick={that.setInstruction(item)}>
                    <span>{item.name}</span>
                </div>
            )
        })
        let inquiryLi = this.state.inquiryInstructionList.map(function (item, index) {
            return (
                <div className="content-item" key={item.instructionId} onClick={that.setInstruction(item)}>
                    <span>{item.name}</span>
                </div>
            )
        })
        const setContent = <div className="baobiao-content">{setLi}</div>
        const controlContent = <div className="baobiao-content">{controlLi}</div>
        const inquiryContent = <div className="baobiao-content">{inquiryLi}</div>
        let setBtn;
        if (this.state.setInstructionList.length) {
            setBtn = <Popover transitionName=""
                    content={setContent}
                    title={null}
                    placement="bottomLeft"
                    visible={setVisible}
                    overlayClassName="device-popover"
                    onVisibleChange={this.handleSetVisibleChange}
                    trigger="hover"
                    >
                    <div className="directive_row h30">
                        <span>{Strings.set || "设置"}</span>
                        <i className=" xiala"/>
                    </div>
                </Popover>
        }
        let controlBtn;
        if (this.state.controlInstructionList.length) {
            controlBtn = <Popover transitionName=""
                content={controlContent}
                title={null}
                visible={controlPopoverVisible}
                overlayClassName="device-popover"
                onVisibleChange={this.handleControlPopoverVisibleChange}
                placement="bottom"
                trigger="hover">
                <div className="directive_row">
                    <span>{Strings.rs10352}</span>
                    <i className=" xiala"/>
                </div>
            </Popover>
        }
        let inquiryBtn;
        if (this.state.inquiryInstructionList.length) {
            inquiryBtn = <Popover transitionName=""
                overlayClassName="device-popover"
                content={inquiryContent}
                title={null}
                visible={inquiryPopoverVisible}
                onVisibleChange={this.handleInquiryPopoverVisibleChange}
                placement="bottom"
                trigger="hover">
                <div className="directive_row h30">
                    <span>{Strings.search1 || "查询"}</span>
                    <i className=" xiala"/>
                </div>
            </Popover>
        }
        let customBtn;
        if (this.state.customInstructionList.length) {
            customBtn = <Button className="w200 mgr15 h30 flex-row ant-btn-reset"
             onClick={that.setInstruction(that.state.customInstructionList[0])}>
               {this.state.customInstructionList[0].name}
            </Button>
        }
        let deviceTip;
        if (record && record.deviceStatus) {
            if (record.deviceStatus === 10) {//离线
                deviceTip = <span className="directive-help">
                    {Strings["enums.deviceStatus.10"] || "离线"}({Strings.latestActiveTime || "最后信号时间："}{this.state.heartTime}) ({Strings.supportOffline || "支持离线指令"})
                    <div className="help-tip">
                        <dl className="tip-node" style={{height: 20,marginBottom:20}}>
                            <dt>{Strings.question || "问题"}</dt>
                            <dd><p id="status-tip-question">{Strings.question1 || "为什么发送命令后设备离线显示，而在“监视器”页面上显示为在线"}?</p></dd>
                        </dl>
                        <dl className="tip-node">
                            <dt>{Strings.answer || "回答："}</dt>
                            <dd>
                                <dl className="tip-node">
                                    <dt>1</dt>
                                    <dd>
                                        <p style={{paddingLeft: 35}}>
                                            {Strings.directiveTips2 || "设备确实处于离线状态"}
                                            ({Strings.directiveTips1 || "理由：未将数据发送到平台时，设备被判定为离线"} )</p>
                                    </dd>
                                </dl>
                                <dl className="tip-node">
                                    <dt style={{paddingLeft: 36}}>2</dt>
                                    <dd>
                                        <p style={{paddingLeft: 35}}> {Strings.directiveTIps3 || "如果我们将设备设置为立即离线显示，则设备有时可能总是离线显示"}. </p>
                                    </dd>
                                </dl>
                                <dl className="tip-node">
                                    <dt style={{paddingLeft: 36}}>3</dt>
                                    <dd>
                                        <p style={{paddingLeft: 35}}>{Strings.directiveTips4 || "所以我们设计了延迟离线设置"}: {Strings.directiveTips5 || "连续一段时间（例如25分钟）未将数据发送到平台后，设备才会显示离线状态"}. </p>
                                    </dd>
                                 </dl>
                            </dd>
                        </dl>
                    </div>
                </span>
            } else {
                deviceTip = <span style={{color:'#6E737F',fontSize:13}}>{Strings.latestActiveTime  || "最后信号时间："} {this.state.heartTime}</span>
            }
        }
        if (record && (!record.deviceStatus || record.deviceStatus === 20)) {//未启用
            deviceTip = <span>{Strings["enums.deviceStatus.20"] || "未启用"}</span>
        }
        return (
            <div className="infoWrapper boxmg white pd15" style={{maxHeight:this.props.maxH?this.props.maxH:"",height:this.props.maxH?this.props.maxH:"auto"}}>
               {deviceTip? <div style={{paddingBottom: 15}}>
                    {deviceTip}
                </div>:null}
                <div style={{paddingBottom: 15,display:'flex'}}>
                    <div style={{display:'flex'}}>
                        {setBtn} {controlBtn} {inquiryBtn}{customBtn}
                    </div>
                    <div
                        className="directive_record_btn"
                        onClick={this.showRecord}>
                        {Strings.directiveRecord || "指令记录"}
                        <div className="hover_mask"/>
                        <div className="active_mask"/>
                    </div>
                </div>
                {showDirective?
                 <div style={{minHeight: 400}}>
                        <SendDirective ref="sendDirective" platform={this.props.platform}
                                       refreshDirectiveList={this.props.refreshDirectiveList}
                                       instruction={this.state.instruction}
                                       directiveList={this.state.directiveList}
                                       isOnline={this.state.isOnline}
                                       showDirective={this.state.showDirective}/>
                    </div>:null}
                {showRecord?<div >
                        <DeviceDirectiveRecord
                            ref="record"
                            refreshDirectiveList={this.props.refreshDirectiveList}
                            record={this.state.record} maxH={this.props.maxH}/>
                    </div> :null}
            </div>


        )
    }
}
export default DeviceDirective
